/**
 * Copyright Mántum All Rights Reserved.
 */
export type PropTypes = {
    children?: React.ReactNode;
};

export default function Tab(props: PropTypes) {
    return (
        <ul
            className='-mb-px flex overflow-x-auto text-center text-sm font-medium'
            role='tablist'
        >
            {props.children}
        </ul>
    );
}
